<template>
  <div class="dates filter-form">
    <div class="calendar-inner">
      <date-input v-model="selected.from"
                  class="from"
                  :placeholder="`${this.$t('_period.from').toLowerCase()}...`"
                  name="from"
                  ref="from"
                  :required="false"
                  :unlimited="true"
                  :is-open="true"
                  :label="`${this.$t('_period.from').toLowerCase()}...`"
                  v-on:input="fromDateChanged"
      />

      <date-input v-model="selected.to"
                  class="to"
                  :placeholder="`${this.$t('_period.to').toLowerCase()}...`"
                  name="to"
                  ref="to"
                  :required="false"
                  :unlimited="true"
                  :is-open="true"
                  :label="`${this.$t('_period.to').toLowerCase()}...`"
                  v-on:input="toDateChanged"
    />
    </div>
    <p class="text-right">
      <b-button class="btn-as-link" @click="reset">
        {{ $t('_reset') }}
      </b-button>
    </p>
  </div>
</template>

<script>
import dateInput from '@/components/frontoffice/form/baseInput/date'
import filtersMixin from "./mixin";
import dateRangeMixin from '@/components/frontoffice/mixins/dateRange'

export default {
  components: {
    dateInput
  },

  mixins: [filtersMixin, dateRangeMixin],

  data () {
    return {
      selected: {
        from: null,
        to: null
      }
    }
  },

  methods: {
    reset () {
      this.selected = {
        from: null,
        to: null
      }
      this.$refs.from.setDate(null)
      this.$refs.to.setDate(null)
      this.emitChanges()
    }
  }
}
</script>
